module.exports = __webpack_public_path__ + "media/yinxiao.4589b423.mp3";